import React from 'react';
import { Hand, Play } from 'lucide-react';
import Navbar from './components/Navbar';
import AITrainerKitAdvantages from './components/AI-Trainer-Kit-Advantage';
import WhyChooseAITrainerKit from './components/Why-Choose-AI-Trainer-Kit';
import MoreDetailsFAQ from './components/Additional-AI-Trainer-Kit';
import Footer from './components/Footer';
import HandsOnProjectsSection from './components/AI-Hands-On-Prototypes';
import AIEducationLanding from './components/AI-Kit-Future-Ready';
import AITrainerCTA from './components/AI-Learn-More';

const AITrainerKit = () => {
  return (
    <div>
      {/* Hero Section with Dark Background */}
      <Navbar />
      <div style={{
        backgroundColor: '#1a1a2e',
        minHeight: '120vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '40px 20px',
        position: 'relative',
        background: 'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 50%, #16213e 100%)',
      }}>
        {/* Global AI Society Header */}
        <div style={{
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          borderRadius: '25px',
          padding: '8px 20px',
          marginBottom: '40px',
          backdropFilter: 'blur(10px)',
        }}>
          <p style={{
            color: '#6b7bff',
            fontSize: '14px',
            margin: '0',
            fontWeight: '500',
            letterSpacing: '0.5px'
          }}>
            Global AI Society Presents
          </p>
        </div>

        {/* Main Title */}
        <h1 style={{
          fontSize: 'clamp(3rem, 8vw, 6rem)',
          fontWeight: '700',
          background: 'linear-gradient(135deg, #6b7bff 0%, #9b59b6 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          textAlign: 'center',
          margin: '0 0 20px 0',
          lineHeight: '1.1',
          letterSpacing: '-2px'
        }}>
          AI Trainer Kit
        </h1>

        {/* Subtitle */}
        <p style={{
          fontSize: '1.5rem',
          color: '#a0a0a0',
          textAlign: 'center',
          margin: '0 0 40px 0',
          fontWeight: '300',
          letterSpacing: '0.5px'
        }}>
          Portable, Powerful & Affordable
        </p>

        {/* Description */}
        <div style={{
          maxWidth: '900px',
          textAlign: 'center',
          margin: '0 0 50px 0'
        }}>
          <p style={{
            fontSize: '1.1rem',
            color: '#c0c0c0',
            lineHeight: '1.8',
            margin: '0',
            fontWeight: '300',
            textAlign: 'justify'
          }}>
            The AI Trainer Kit is a first-of-its-kind, portable AI learning device powered by Intel, designed to 
            empower students and educators across the world. Whether you're in a classroom, lab, innovation hub, 
            or even a remote learning setup — this Intel-powered, plug-and-play kit delivers hands-on, real-world 
            AI training on the go.
          </p>
          <p style={{
            fontSize: '1.1rem',
            color: '#c0c0c0',
            lineHeight: '1.8',
            margin: '0',
            fontWeight: '300',
            textAlign: 'justify'
          }}>
            Built with global educational standards in mind, the AI Trainer Kit is aligned with key frameworks such as India's NEP 2020, UNESCO's Future of
            Education initiative, the 21st Century Skills Framework, and the U.S. K–12 Computer Science Standards including CSTA guidelines. Whether you're
            implementing AI education in India, the United States, or anywhere across the globe, this fully portable, plug-and-play kit makes it easy to deliver practical,
            hands-on AI learning in any classroom, lab, or remote environment.
          </p>
        </div>

        {/* Buttons */}
        <a href="https://www.youtube.com/watch?v=hdImrY-ZSqg" target='_blank' style={{
            textDecoration: 'none'
        }}>
        <div style={{
          display: 'flex',
          gap: '20px',
          flexWrap: 'wrap',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          {/* Learn More Button */}
          <button style={{
            background: 'linear-gradient(135deg, #6b7bff 0%, #9b59b6 100%)',
            color: 'white',
            border: 'none',
            padding: '15px 35px',
            fontSize: '16px',
            fontWeight: '600',
            borderRadius: '50px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 20px rgba(107, 123, 255, 0.3)',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            minWidth: '160px',
            justifyContent: 'center'
          }}
          onMouseOver={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 6px 25px rgba(107, 123, 255, 0.4)';
          }}
          onMouseOut={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 20px rgba(107, 123, 255, 0.3)';
          }}>
            <Play size={16} />
            Watch Demo
          </button>
        </div>
        </a>
      </div>

     
      <AITrainerKitAdvantages />
      <WhyChooseAITrainerKit />
      <HandsOnProjectsSection />
      <AIEducationLanding />
      <MoreDetailsFAQ />
      <AITrainerCTA />
      <Footer />
    </div>
  );
};

export default AITrainerKit;

/*import React from 'react';
import Navbar from './components/Navbar';
import AITrainerKitAdvantages from './components/AI-Trainer-Kit-Advantage';
import WhyChooseAITrainerKit from './components/Why-Choose-AI-Trainer-Kit';
import MoreDetailsFAQ from './components/Additional-AI-Trainer-Kit';
import Footer from './components/Footer';

const AITrainerKit = () => {
  return (
    <div>
      <div style={{
        fontFamily: 'Arial, sans-serif',
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '60px 40px',
        backgroundColor: '#fefefe',
        lineHeight: '1.6'
      }}>
          <Navbar />
        <div style={{
          textAlign: 'center',
          marginBottom: '80px',
          marginTop: '8em',
        }}>
          <h1 style={{
            fontSize: '3.5rem',
            fontWeight: '300',
            color: '#E6B800',
            margin: '0',
            letterSpacing: '0.5px',
            position: 'relative'
          }}>
            AI Trainer Kit – Portable, Powerful & Affordable
            <div style={{
              position: 'absolute',
              bottom: '-10px',
              right: '0',
              width: '200px',
              height: '2px',
              backgroundColor: '#333',
              transform: 'translateY(50%)'
            }}></div>
          </h1>
        </div>

        <div style={{
          display: 'grid',
          gap: '40px',
          fontSize: '1.1rem',
          color: '#333',
          textAlign: 'justify'
        }}>
          <p style={{
            margin: '0',
            lineHeight: '1.8'
          }}>
            The AI Trainer Kit is a first-of-its-kind, portable AI learning device powered by Intel, designed to empower students and educators across the world. 
            Whether you're in a classroom, lab, innovation hub, or even a remote learning setup — this Intel-powered, plug-and-play kit delivers hands-on, real-world 
            AI training on the go.
          </p>

          <p style={{
            margin: '0',
            lineHeight: '1.8'
          }}>
            Built with global educational standards in mind, the AI Trainer Kit is aligned with key frameworks such as India's NEP 2020, UNESCO's Future of 
            Education initiative, the 21st Century Skills Framework, and the U.S. K–12 Computer Science Standards including CSTA guidelines. Whether you're 
            implementing AI education in India, the United States, or anywhere across the globe, this fully portable, plug-and-play kit makes it easy to deliver practical, 
            hands-on AI learning in any classroom, lab, or remote environment.
          </p>
        </div>

        <div style={{
          marginTop: '60px',
          textAlign: 'center'
        }}>
          <button style={{
            backgroundColor: '#E6B800',
            color: 'white',
            border: 'none',
            padding: '15px 40px',
            fontSize: '1.1rem',
            borderRadius: '5px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 2px 10px rgba(230, 184, 0, 0.3)'
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = '#d4a600';
            e.target.style.transform = 'translateY(-2px)';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = '#E6B800';
            e.target.style.transform = 'translateY(0)';
          }}>
            Learn More
          </button>
        </div>
        <AITrainerKitAdvantages />
        <WhyChooseAITrainerKit />
      </div>
      <MoreDetailsFAQ />
      <Footer />
    </div>
  );
};

export default AITrainerKit;*/